import _ from 'lodash';

import Config from '@skin_config';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';

import { SetTerminalBalance } from '../actions/terminal';
import { store } from '../index/terminalApp';
import { setBalanceToTerminal } from './balance';

export const getTerminalBalance = () => {
  const state = store.getState();
  const terminalBalance = state.terminal.balance?.session_balance;
  const userBalance = state.user.profile?.balance;

  if (userBalance || userBalance === 0) return userBalance;

  if (!_.isNil(terminalBalance)) return terminalBalance;

  return 0;
};

export class TerminalBalanceFetcher {
  static pollingEnabled = false;

  static timer = null;

  static enablePolling() { TerminalBalanceFetcher.pollingEnabled = true; }

  static shouldPoll = () => {
    const state = store.getState();
    const noUser = !state.user.profile;

    return TerminalBalanceFetcher.pollingEnabled && noUser;
  };

  static scheduleNextPoll = () => {
    if (!Config.main.enableTerminalBalancePolling) return;

    if (TerminalBalanceFetcher.timer) clearTimeout(TerminalBalanceFetcher.timer);

    TerminalBalanceFetcher.timer = setTimeout(() => {
      TerminalBalanceFetcher.fetchAndStore(true);
    }, Config.main.terminalBalancePollingInterval * 1000);
  };

  static fetchAndStore = async (polling) => {
    try {
      if (polling && !TerminalBalanceFetcher.shouldPoll()) {
        return TerminalBalanceFetcher.scheduleNextPoll();
      }

      const { token } = JSON.parse(sessionStorage.getItem('authData'));

      const response = await swarmRequest({ token }, 'get_terminal_balance');

      if (response?.status_code !== 0) return TerminalBalanceFetcher.scheduleNextPoll();

      store.dispatch(
        SetTerminalBalance({
          session_balance: response.data?.session_balance,
        }),
      );

      setBalanceToTerminal(response.data?.session_balance);

      return TerminalBalanceFetcher.scheduleNextPoll();
    } catch {
      return TerminalBalanceFetcher.scheduleNextPoll();
    }
  };

  static debouncedFetchAndStore = _.debounce(TerminalBalanceFetcher.fetchAndStore, 1500);
}
